import { SET_COMPARE_TREND } from '../../actions/chart';

export default (state = null, action) => {
  switch (action.type) {
    case SET_COMPARE_TREND:
      return action.payload.id;
    default:
      return state;
  }
};

export const getCompareTrend = state => state;